DOMReady(function() {
  jQuery(document).foundation();

  // Break syntax of accordion if any available
  // Look in custom/init-break-accordion.js
  initBreakAccordion();
});